// extracted by mini-css-extract-plugin
module.exports = {"header":"_835e9","wrapper":"d193f","row":"d9d1b","item":"de9ba","logotype":"_3a17b","link":"b1377"};